import React, { useState } from "react";

const DEFAULT_MSG = "By subscribing, you agree to receive updates from MusicUntamed. You can unsubscribe at any time.";
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(DEFAULT_MSG);
  const [status, setStatus] = useState("idle"); // idle | success | error

  const handleSubmit = (e) => {
    e.preventDefault();

    if (EMAIL_PATTERN.test(email.trim())) {
      setStatus("success");
      setMessage("You're in! Thanks for subscribing — check your inbox to confirm.");
      setEmail("");
    } else {
      setStatus("error");
      setMessage("Please enter a valid email address.");
      setTimeout(() => {
        setStatus("idle");
        setMessage(DEFAULT_MSG);
      }, 2500);
    }
  };

  const messageColor =
    status === "success" ? "#2b1656" : status === "error" ? "#5a2c14" : "#5a2c14";

  return (
    <div className="newsletter-wrap">
      <div className="newsletter-card">
        <h2>Stay in the Loop</h2>
        <p>
          Be the first to hear about new music, exclusive interviews, artist releases, events,
          promotions, and cultural stories delivered straight to your inbox.
        </p>
        <form className="newsletter-form d-flex" onSubmit={handleSubmit} noValidate>
          <input
            type="email"
            className="form-control"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="btn">Subscribe</button>
        </form>
        <div
          className="newsletter-fine"
          style={{ color: messageColor, fontWeight: status === "idle" ? 400 : 600 }}
        >
          {message}
        </div>
      </div>
    </div>
  );
}
